var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18279_6295)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5155 3.82837L16.1104 9.9998L19.5155 16.1712L20.9104 15.4291V4.5705L19.5155 3.82837Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2311 3.82837L12.3923 4.5705L8.91113 9.9998L12.3923 15.4291L19.2311 16.1712V3.82837Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26749 3.82837L4.11035 4.29709V15.7025L5.26749 16.1712L12.5104 9.9998L5.26749 3.82837Z",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55078 3.82837L12.5108 5.66593V14.507L5.55078 16.1712V3.82837Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5145 6.57126L9.39062 6.09016L12.5145 2.68555L15.6306 6.09016L12.5145 6.57126Z",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6306 6.08371L12.5106 6.57126L9.39062 6.08371V2.68555",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5145 13.4285L9.39062 13.9391L12.5145 16.6285L15.6306 13.9391L12.5145 13.4285Z",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5009 0.399902L9.39062 1.91838V6.11419L12.5106 5.30168L12.5009 0.399902Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5106 7.4856L9.39062 7.79621V11.9589L12.5106 12.2856V7.4856Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5106 14.6179L9.39062 13.8855V18.0712L12.5106 19.5998V14.6179Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6307 13.8855L12.5107 14.6181V19.5998L15.6307 18.0712V13.8855Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5107 7.4856L15.6307 7.79621V11.9589L12.5107 12.2856V7.4856Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5107 0.399902L15.6307 1.91838V6.11419L12.5107 5.31499V0.399902Z",
    fill: "#E25444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18279_6295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white",
    transform: "translate(0.510742 0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3Icon);
export default __webpack_public_path__ + "static/media/S3-icon.cc1dcf4725080d9bc97d05917f81ce81.svg";
export { ForwardRef as ReactComponent };